import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapperStyles = css`
  border-top: 1px solid ${colors.yellow};
  border-bottom: 1px solid ${colors.yellow};
  ${media.max(BreakPoints.tablet)} {
    min-height: 350px;
  }
`
export const BackgroundWrapperStyles = css``
export const BackgroundStyles = css`
  border: none;

  &:not(:first-child) {
    border-left: 0;
  }
`
export const BannerWrapperStyles = css`
  display: flex;
  flex-direction: column;

  &.right {
    align-items: end;
    ${media.max(BreakPoints.tablet)} {
      align-items: center;
    }
  }

  &.left {
    align-items: start;
  }

  &.center {
    align-items: center;
  }
  ${media.max(BreakPoints.tablet)} {
    height: 100%;
    justify-content: end;
    align-items: center;
  }
`
export const ContentWrapperStyles = css`

  ${media.max(BreakPoints.tablet)} {
    min-height: 350px;
    h2{
      text-align: center;
      margin: 0;
      font-size: 35px
    }
  }
`
export const ContentStyles = css`
  ${media.max(BreakPoints.tablet)} {
    height: 100%;
  }
`
export const ContentDescriptionStyles = css`
`
export const ContentButtonsStyles = css`
  ${media.max(BreakPoints.tablet)} {
    flex-direction: column;
    justify-content: center;
    margin: 3px auto;
    a{
      margin: 6px 0;
    }
  }
`
